import type { AlertEvent } from "@/types/alerting";
import { dateFormatterGenerator, dateDifference } from "./date";
import moment from "moment";

export const dateFormatterStart = (row: AlertEvent) => {
  return dateFormatterGenerator(
    row.dateStart,
    row.project ? row.project.place.timezone : undefined,
  );
};
export const dateFormatterEnd = (row: AlertEvent) => {
  return dateFormatterGenerator(
    row.dateEnd,
    row.project ? row.project.place.timezone : undefined,
  );
};

export const calculateDuree = (
  dateStart: any,
  dateEnd: any,
  lastTrigger: any,
  alertViewSampling = { samplingUnit: "", sampling: "" },
) => {
  const samplings: string[] = ["days", "hours", "weeks", "months"];
  const lastToShow = !samplings.includes(alertViewSampling.samplingUnit)
    ? lastTrigger
    : moment(lastTrigger).add(
        1,
        alertViewSampling.samplingUnit as moment.unitOfTime.DurationConstructor,
      );

  const endPeriod = dateEnd ? dateEnd : lastTrigger ? lastToShow : new Date();
  return `${dateDifference(dateStart, endPeriod)}`;
};
